import { Image as ExpoImage } from "expo-image";

export const Image = (props) => {
    return <ExpoImage {...props} />;
}

export const NoContextImage = (props) => {
    return (
        <ExpoImage 
            onContextMenu={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }} 
            {...props} 
        />
    );
}